import React, { useEffect, useState } from 'react';
import { Button, Space, Table, message } from 'antd';
import { Adminauthcontexthooks } from '../../Hooks/Adminauthcontexthooks';


const Courtcalndertable = () => {
    const columns = [
        {
            title: 'Year',
            dataIndex: 'UplaodingYear',
            key: 'UplaodingYear',
        },
        {
            title: 'Download File Link',
            dataIndex: 'Courtcalenderimg',
            key: 'Courtcalenderimg',
            render: text => (
                <a
                    // href={`https://cdr-backend.onrender.com/uploads/${text}`}
                    href={text}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    View File
                </a>
            ),
        },
        {
            title: 'Action',
            key: 'action',
            render: (id, record) => (
                <Space size="middle">
                    <Button color="red" variant="dashed" onClick={() => DelCourtcalender(id)} loading={subbtnloading} disabled={subbtnloading}>Delete</Button>
                </Space>
            ),
        },
    ];
    const { user } = Adminauthcontexthooks();
    const [data, setdata] = useState([]);
    const [loading, setloading] = useState(true);
    const [subbtnloading, setsubbtnloading] = useState(false);

    const GetCourtcalenders = async () => {
        const res = await fetch('https://cdr-backend.onrender.com/get/courtcalenders', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${user}`
            }

        });
        const data = await res.json();
        if (res.status === 200) {
            setdata(data.CourtcalendrOBJ);
            setloading(false);
        }
    }
    const DelCourtcalender = async (obj) => {
        const id = obj._id
        setsubbtnloading(true);
        const res = await fetch(`https://cdr-backend.onrender.com/delete/courtcalender/${id}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${user}`
            }
        });
        if (res.status === 200) {
            message.success("File deleted successfully");
            setsubbtnloading(false);
            GetCourtcalenders();
            return;
        } else {
            message.error("Something went wrong");
            setsubbtnloading(false);
            return;
        }
    }

    useEffect(() => {
        if (user) {
            const GetCourtcalenders = async () => {
                const res = await fetch('https://cdr-backend.onrender.com/get/courtcalenders', {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${user}`
                    }

                });
                const data = await res.json();
                if (res.status === 200) {
                    setdata(data.CourtcalendrOBJ);
                    setloading(false);
                }
            }
            GetCourtcalenders()
        }

    }, [data, user])
    return (
        <>
            <Table columns={columns} dataSource={data} loading={loading} />
        </>
    )
}

export default Courtcalndertable;